import { render, staticRenderFns } from "./DashFeesRate.vue?vue&type=template&id=41dcb17a&scoped=true&"
import script from "./DashFeesRate.vue?vue&type=script&lang=js&"
export * from "./DashFeesRate.vue?vue&type=script&lang=js&"
import style0 from "./DashFeesRate.vue?vue&type=style&index=0&id=41dcb17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcb17a",
  null
  
)

export default component.exports